export default __webpack_public_path__ + "static/media/dl-2.b7f88530.png";